<script setup lang="ts">
import { MMLink, MMIcon, MMText } from '@mm-frontend/mm-web-ui-kit';

const props = defineProps<{
  title: string;
  iconLink?: string;
  iconSvg?: string;
  isPromo?: boolean;
  to?: string;
  isSelected?: boolean;
}>();
</script>

<template>
  <MMLink
    :to="props.to"
    design="neutral"
    underline="none"
    class="catalog-link"
    :class="{
      'catalog-link--promo': props.isPromo,
      'catalog-link--selected': props.isSelected,
    }"
  >
    <div class="catalog-link__icon">
      <img v-if="props.iconLink" :src="props.iconLink" alt="" />
    </div>

    <MMText
      font="Body M/Medium"
      class="catalog-link__title"
      :class="{ 'catalog-link__title--selected': props.isSelected }"
    >
      {{ props.title }}
    </MMText>

    <MMIcon
      v-if="!props.isPromo"
      name="chevron"
      class="catalog-link__arrow"
      :angle="-90"
      :height="16"
      :width="16"
    />
  </MMLink>
</template>

<style scoped lang="stylus">
.catalog-link
  display flex
  align-items center
  justify-content space-between
  gap 8px
  width 100%
  padding 4px 8px
  box-sizing border-box
  border-radius 8px

  &:not(.catalog-link--promo)
    &:hover, &.catalog-link--selected
      background-color var(--button-tertiary-neutral-onprimary-hovered)

  &:hover
    & .catalog-link__title
      color var(--text-accented)

  &__icon
    width 24px
    height 24px
    border-radius 50%

    & img
      width 100%
      height 100%
      display block
      object-fit cover

  &__title
    flex 1
    transition color var(--default-transition-duration) var(--default-transition-timing-function)
</style>
